/**
 * Compares simple to complex object
 * @param first first object to compare
 * @param second second object to compare
 */
export const isEqual = (first: any, second: any): boolean => {
    // check if one of them is either undefined or null
    if (
        (!first && !!second) ||
        (!!first && !second) ||
        (first === null && second === undefined) ||
        (first === undefined && second === null)
    )
        return false

    // If first and second are the same type and have the same value
    // Useful if strings or other primitive types are compared
    if (first === second) return true

    // Try a quick compare by seeing if the length of properties are the same
    let firstProps = Object.getOwnPropertyNames(first)
    let secondProps = Object.getOwnPropertyNames(second)

    // Check different amount of properties
    if (firstProps.length != secondProps.length) return false

    // Go through properties of first object
    for (var i = 0; i < firstProps.length; i++) {
        let prop = firstProps[i]
        // Check the type of property to perform different comparisons
        switch (typeof first[prop]) {
            // If it is an object, descend for deep compare
            case 'object':
                if (!isEqual(first[prop], second[prop])) return false
                break
            case 'function':
                if (first[prop].toString() !== second[prop].toString())
                    return false
                break
            case 'number':
                // with JavaScript NaN != NaN so we need a special check
                if (isNaN(first[prop]) && isNaN(second[prop])) return false
                break
            default:
                if (first[prop] != second[prop]) return false
        }
    }

    return true
}

/**
 * Gets cookie from document.
 * https://www.w3schools.com/js/js_cookies.asp
 * @param cookieKey
 */
export const getCookie = (cookieKey: string) => {
    var name = cookieKey + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

export interface SetCookieProps {
    name: string
    value: string
    expirationInSeconds: number
}

/**
 * Sets cookie in document.
 * https://www.w3schools.com/js/js_cookies.asp
 * @param setCookieProps
 */
export const setCookie = ({
    name,
    value,
    expirationInSeconds,
}: SetCookieProps) => {
    var d = new Date()
    d.setTime(d.getTime() + expirationInSeconds * 1000)
    var expires = 'expires=' + d.toUTCString()
    document.cookie = `${name}=${value};${expires};path=/`
}
